import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import setupDirective from "./lib/directive/directive";
import i18n from "./i18n/i18n.js";
import VConsole from "vconsole";
import VueLazyload from "vue-lazyload";
import { isDev, getUrlAllParams } from "@/utils/tools.js";
import vue3GoogleLogin from "vue3-google-login";
import firebaseFuctionInit from "@/utils/analytic/firebaseUtils.js";
import fc from "@/components/functionComp/index";
import "@/assets/css/css.js";
import * as Sentry from "@sentry/vue";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import defaultCover from "@/assets/img/default-cover-3x.png";
import { isMobileDevice } from "./utils/tools.js";
import "virtual:svg-icons-register";
import layoutConfig, { initLayout } from "@/config/layoutConfig.js";
// or with options    // 带参数注册指令

const { source, bd_vid } = getUrlAllParams(decodeURIComponent(location.href));
if (source) {
  window.sessionStorage.setItem(
    `ad_source`,
    JSON.stringify({
      source: source,
      bd_vid: bd_vid ?? "",
    })
  );
}

let app = null;

app = createApp(App);

app.use(fc);
setupDirective(app);
app.use(router);
app.use(store);
app.use(i18n);
app.use(firebaseFuctionInit);
app.use(vue3GoogleLogin, {
  clientId:
    "1069642802272-0ktgtg6hn72ljht0bltd9h14qseflsvj.apps.googleusercontent.com",
  scope: "profile email",
});
app.use(VueLazyload, {
  preLoad: 1.3, // proportion of pre-loading height, 个人理解是图片加载前目标元素位置范围
  error: defaultCover, // 加载错误时
  loading: defaultCover, // 加载中
  attempt: 3, // 下载图片时错误重连次数
  //... 还可以设置更多参数，如触发事件
});
app.mount("#app");
if (isDev() && isMobileDevice()) {
  window.__vConsole = new VConsole({ theme: "dark" });
}
// }

const setSentryUid = async () => {
  const u_id = await firebaseUtils?.getAnonymousID();
  Sentry.setUser({ id: u_id });
};

setSentryUid();

function onResize() {
  const type = window.innerWidth > 768 ? "pc" : "mobile";
  if (type == layoutConfig.renderType) return;
  initLayout();
  // 在窗口大小变化时重新加载路由
  // 设备没有变化，取消重新渲染
  // 普通页面不重新渲染
}

// 初始加载
// initializeApp();
initLayout()
window.addEventListener("resize", onResize);
